import store from "@/store";
import request from "@/utils/extRequest";

export async function getLmReferenceBookList(params) {
    console.log("@@ get list : getLmReferenceBookList");
    let result = request.get("/api/ext/prd/",{params});
    return result;
}

export async function getLmReferenceBookitem(params) {
    console.log("@@ get item : getLmReferenceBookitem");
    let result = request.get(`/api/ext/prd/${params.bookSeq}`,{params} );
    return result;
}

export async function getTextbookAtrbRelInfoList(params) {
    console.log("@@ get list : getTextbookAtrbRelInfoList");
    let result = request.get("/api/ext/textbookAtrbRelInfo/",{params});
    return result;
}
